import dashboardService from '@Dashboard/service/rbi-dashboard.service'
import { log, warn, error } from '@/utils/debugLogger';
export const RBI_DASHBOARD = {
    namespaced: true,
    state: {
        rfbiCount: 0,
        dfCount: 0,
        iowCount: 0,
        loading: false,
        currentRiskMatrix: new Array(5).fill(null).map(() => new Array(5).fill(0)),
        futureRiskMatrix:new Array(5).fill(null).map(() => new Array(5).fill(0)),
        futureRiskWithInspectionsMatrix:new Array(5).fill(null).map(() => new Array(5).fill(0)),
    
        // Keep alive
        viewerOpened: false,
        activeCard: null,
        selectedCurrentRiskMatrix: [],
        selectedFutureRiskMatrix: [],
        selectedFutureRiskWithInspectionsMatrix: [],
        selectedRowsData: [],
        coloredInspections: []
    },
    getters: {
        GET_RFBI_COUNT(state) {
            return state.rfbiCount;
        },
        GET_DF_COUNT(state) {
            return state.dfCount;
        },
        GET_IOW_COUNT(state) {
            return state.iowCount;
        },
        GET_FUTURE_RISK_MATRIX(state) {
            return state.futureRiskMatrix;
        },
        GET_FUTURE_RISK_W_INSPECTIONS_MATRIX(state) {
            return state.futureRiskWithInspectionsMatrix;
        },
        GET_CURRENT_RISK_MATRIX(state) {
            return state.currentRiskMatrix;
        },
        GET_LOADING(state) {
            return state.loading;
        },
        GET_VIEWER_OPENED(state) {
            return state.viewerOpened;
        },
        GET_ACTIVE_CARD(state) {
            return state.activeCard;
        },
        GET_SELECTED_CURRENT_RISK_MATRIX(state) {
            return state.selectedCurrentRiskMatrix;
        },
        GET_SELECTED_FUTURE_RISK_MATRIX(state) {
            return state.selectedFutureRiskMatrix;
        },
        GET_SELECTED_FUTURE_RISK_WITH_INSPECTIONS_MATRIX(state) {
            return state.selectedFutureRiskWithInspectionsMatrix;
        },
        GET_SELECTED_ROWS_DATA(state) {
            return state.selectedRowsData;
        },
        GET_COLORED_INSPECTIONS(state) {
            return state.coloredInspections;
        }
    },
    mutations: {
        SET_RFBI_COUNT(state,value) {
             state.rfbiCount=value;
        },
        SET_DF_COUNT(state,value) {
             state.dfCount=value;
        },
        SET_IOW_COUNT(state,value) {
             state.iowCount=value;
        },
        SET_FUTURE_RISK_MATRIX(state,value) {
             state.futureRiskMatrix=value;
        },
        SET_FUTURE_RISK_W_INSPECTIONS_MATRIX(state,value) {
             state.futureRiskWithInspectionsMatrix=value;
        },
        SET_CURRENT_RISK_MATRIX(state,value) {
             state.currentRiskMatrix=value;
        },
        SET_LOADING(state,value) {
             state.loading=value;
        },
        SET_VIEWER_OPENED(state,value) {
            state.viewerOpened = value
        },
        SET_ACTIVE_CARD(state,value) {
            state.activeCard = value
        },
        SET_SELECTED_CURRENT_RISK_MATRIX(state,value) {
            state.selectedCurrentRiskMatrix = value
        },
        SET_SELECTED_FUTURE_RISK_MATRIX(state,value) {
            state.selectedFutureRiskMatrix = value
        },
        SET_SELECTED_FUTURE_RISK_WITH_INSPECTIONS_MATRIX(state,value) {
            state.selectedFutureRiskWithInspectionsMatrix = value
        },
        SET_SELECTED_ROWS_DATA(state,value) {
            state.selectedRowsData = value
        },
        SET_COLORED_INSPECTIONS(state,value) {
            state.coloredInspections = value
        }
    },
    actions: {
        RESET({ commit }) {
            commit('SET_VIEWER_OPENED', false);
            commit('SET_ACTIVE_CARD', null);
            commit('SET_SELECTED_CURRENT_RISK_MATRIX', []);
            commit('SET_SELECTED_FUTURE_RISK_MATRIX', []);
            commit('SET_SELECTED_FUTURE_RISK_WITH_INSPECTIONS_MATRIX', []);
            commit('SET_SELECTED_ROWS_DATA', []);
            commit('SET_COLORED_INSPECTIONS', []);
        },
        GET_RFBI_COUNT({ commit }, params) {
            commit('SET_LOADING', true);
            dashboardService.getFrbiCount(params).then((response) => {
                let count = response.data
                commit('SET_RFBI_COUNT', count);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
        GET_DF_COUNT({ commit }, params) {
            commit('SET_LOADING', true);
            dashboardService.getDfCount(params).then((response) => {
                let count = response.data
                commit('SET_DF_COUNT', count);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
        GET_IOW_COUNT({ commit }, params) {
            commit('SET_LOADING', true);
            dashboardService.getIowCount(params).then((response) => {
                let count = response.data
                commit('SET_IOW_COUNT', count);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
        GET_RISK_MATRIX({ commit }, params) {
            commit('SET_LOADING', true);
            dashboardService.getRiskMatrix(params).then((response) => {
                let data = response.data;
                
                var futureRiskMatrix=convertTo2DArray(data.futureRisk );
                var futureRiskWithInspectionsMatrix=convertTo2DArray(data.futureRiskWithInspections );
                var currentRiskMatrix=convertTo2DArray(data.currentRisk );

                commit('SET_FUTURE_RISK_MATRIX', futureRiskMatrix);
                commit('SET_FUTURE_RISK_W_INSPECTIONS_MATRIX',  futureRiskWithInspectionsMatrix);
                commit('SET_CURRENT_RISK_MATRIX',  currentRiskMatrix);
            })
                .catch((error) => {
                    log(error);
                })
                .finally(() => {
                    commit('SET_LOADING', false);
                });
        },
       
    }
} 

function convertTo2DArray(csharpArray) {
    const cols = ['A', 'B', 'C', 'D', 'E'];  
    const rows = [5, 4, 3, 2, 1];            
  
    const resultArray = new Array(rows.length).fill(0).map(() => new Array(cols.length).fill(0));
  
    csharpArray.forEach(item => {
      const colLetter = item.key[1];  // Extract letter part (A-E)
      const rowNumber = parseInt(item.key[0]); // Extract number part (1-5)
  
      const colIndex = cols.indexOf(colLetter);
      const rowIndex = rows.indexOf(rowNumber);
        if(colIndex<0||rowIndex<0)
            return;
      resultArray[rowIndex][colIndex] = item.count;
    });
  
    return resultArray;
  }
  
 
  
  